import { render } from "./MenuClassicPage.vue?vue&type=template&id=77e511d9&ts=true"
import script from "./MenuClassicPage.vue?vue&type=script&lang=ts"
export * from "./MenuClassicPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__